import RESOURCE_TYPES, { Resource } from 'game/RESOURCE_TYPES';

const LOCALIZED_RESOURCE_NAMES: Record<number, string> = {
  [RESOURCE_TYPES.MANA.id]: '法力值',
  [RESOURCE_TYPES.RAGE.id]: '怒气',
  [RESOURCE_TYPES.FOCUS.id]: '集中值',
  [RESOURCE_TYPES.ENERGY.id]: '能量',
  [RESOURCE_TYPES.COMBO_POINTS.id]: '连击点',
  [RESOURCE_TYPES.RUNES.id]: '符文',
  [RESOURCE_TYPES.RUNIC_POWER.id]: '符文能量',
  [RESOURCE_TYPES.SOUL_SHARDS.id]: '灵魂碎片',
  [RESOURCE_TYPES.ASTRAL_POWER.id]: '星界能量',
  [RESOURCE_TYPES.HOLY_POWER.id]: '神圣能量',
  [RESOURCE_TYPES.ALTERNATE_POWER.id]: '特殊能量',
  [RESOURCE_TYPES.MAELSTROM.id]: '漩涡值',
  [RESOURCE_TYPES.CHI.id]: '真气',
  [RESOURCE_TYPES.INSANITY.id]: '狂乱值',
  [RESOURCE_TYPES.ARCANE_CHARGES.id]: '奥术充能',
  [RESOURCE_TYPES.FURY.id]: '恶魔之怒',
  [RESOURCE_TYPES.PAIN.id]: '痛苦',
  [RESOURCE_TYPES.ESSENCE.id]: '精华',
  [RESOURCE_TYPES.MAELSTROM_WEAPON.id]: '漩涡武器',
};

export default function localizedResourceName(resourceOrId: Resource | number | undefined) {
  if (resourceOrId === undefined) {
    return '';
  }

  const id = typeof resourceOrId === 'number' ? resourceOrId : resourceOrId.id;
  return LOCALIZED_RESOURCE_NAMES[id] || (typeof resourceOrId === 'number' ? '' : resourceOrId.name);
}
